module.exports = __webpack_public_path__ + "static/media/slider_felgi.56affb5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider_felgi.jpg
// module id = 830
// module chunks = 0